/**
 * Pull the status and a showable message out of whatever a failed call threw.
 *
 * Axios errors, bare `Error`s and the occasional rejected string all reach the
 * same catch blocks, and every page was re-deriving this shape inline.
 */
export function extractApiError(
  error: unknown,
  fallback = 'Something went wrong. Please try again.'
): { status?: number; message: string } {
  const response = (error as { response?: { status?: number; data?: { message?: string } } })
    ?.response;

  if (response) {
    return { status: response.status, message: response.data?.message ?? fallback };
  }

  if (error instanceof Error && error.message) {
    return { message: error.message };
  }

  return { message: fallback };
}
